$ const { notifications, direction } = state;
<if(notifications && notifications.length)>
  $ {
    const notification = notifications[0];
    const { body, body_html, isError } = notification;

    const animation = direction === 'in' ? 'animate__fadeIn' : 'animate__fadeOut';
  }
  <if(body || body_html)>
    <div class=["app-notification animate__animated", animation] data-direction=direction on-animationend("handleAnimationEnd") on-click("handleClick")>
      <button no-update class="delete" aria-label="Close notification"></button>
      <div class:no-update="container">
        <if(isError)>
          <if(body_html)>
            $!{body_html}
          </if>
          <else-if(body)>
            ${body}
          </else-if>
          <else>
            Cannot process your request. Try again later.
          </else>
        </if>
        <else>
          <if(body_html)>
            $!{body_html}
          </if>
          <else-if(body)>
            ${body}
          </else-if>
        </else>
      </div>
    </div>
  </if>
</if>
